import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import AssetManagementApiService from './AssetManagementApiService'
import { setEditJobTitleData, setIsJobTitleSaved, setJobTitleExcelData, setJobTitleGridData, setSaveMultipleJobTitleStatus } from 'Store/AssetManagement/JobTitle/JobTitleAction';
import { GET_EDIT_JOB_TITLE_DATA_BY_ID, GET_JOB_TITLE_EXCEL_DATA, GET_JOB_TITLE_GRID_DATA, GET_SAVE_JOB_TITLE, GET_SAVE_MULTIPLE_JOB_TITLE_STATUS } from 'Store/AssetManagement/JobTitle/JobTitleType';
import { apiMethod, apiType, API_URL } from 'utils';
import { IPayload } from 'Model/IPayload';

function* getJobTitleGridDataSaga(req: any): any {
    let payloadData : IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `jobtitle/details`,
        payload : req?.payload
    }

    try {
        yield put(globalLoaderText("Fetching Grid data..."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setJobTitleGridData(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setJobTitleGridData([]))
        yield put(globalLoaderText(""));
    }
}

function* getJobTitleExcelDataSaga(req: any): any {
    let payloadData : IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `jobtitle/details/export`,
        payload : req?.payload
    }

    try {
        yield put(globalLoaderText("Exporting Grid data..."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setJobTitleExcelData(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setJobTitleExcelData([]))
        yield put(globalLoaderText(""));
    }
}

function* getSaveJobTitleDataSaga(req: any): any {
    let payloadData : IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `jobtitle`,
        payload : req?.payload
    }

    try {
        yield put(globalLoaderText("Saving Job Title..."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setIsJobTitleSaved(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setIsJobTitleSaved(false))
        yield put(globalLoaderText(""));
    }
}

function* getEditJobTitleDataSaga(req: any): any {
    let payloadData : IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.AssetManagement,
        endpoint: `jobtitle/details/${req?.payload}`,
        payload : req?.payload
    }

    try {
        yield put(globalLoaderText("Saving Job Title..."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setEditJobTitleData(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setEditJobTitleData({}))
        yield put(globalLoaderText(""));
    }
}

function* getSaveMultipleJobTitleStatusSaga(req: any): any {
    try {
        yield put(globalLoaderText("Saving...."));
        let payloadData : IPayload = {
            apiMethod: apiMethod.POST,
            apiType: apiType.AssetManagement,
            endpoint: `jobtitle/updateIsActiveByIds`,
            payload : req?.payload
        }
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setSaveMultipleJobTitleStatus(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setSaveMultipleJobTitleStatus('error'))
        yield put(globalLoaderText(""));
    }
}

function* watchGetFuelType() {
    yield takeEvery(GET_JOB_TITLE_GRID_DATA, getJobTitleGridDataSaga)
    yield takeEvery(GET_JOB_TITLE_EXCEL_DATA, getJobTitleExcelDataSaga)
    yield takeEvery(GET_SAVE_JOB_TITLE, getSaveJobTitleDataSaga)
    yield takeEvery(GET_EDIT_JOB_TITLE_DATA_BY_ID, getEditJobTitleDataSaga)
    yield takeEvery(GET_SAVE_MULTIPLE_JOB_TITLE_STATUS, getSaveMultipleJobTitleStatusSaga)
}

export default function* combinedSaga() {
    yield all([
        watchGetFuelType()
    ])
}